"use client";
import React from "react";
import BlogCard from "./components/BlogCard";
import { blogData } from "./data/blogData";
import SideBlog from "./components/SideBlog";
import { Sun } from "lucide-react";
import Link from "next/link";
import { motion } from "framer-motion";

const Blogs = () => {
    const reversedBlogs = blogData.blogs.slice().reverse();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col gap-8 py-[6rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem]"
    >
      {/* Title Section */}
      <div className="flex flex-col gap-3 mb-4">
        <div className="text-pri text-desc-size2 flex items-center gap-2">
          <Sun size={20} />
          <span>{blogData.title.mainTitle}</span>
        </div>
        <div className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
          {blogData.title.heading}
        </div>
      </div>

      {/* Main Content and SideBlog */}
      <div className="flex flex-row gap-12">
        {/* Blog Cards Grid */}
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 max-w-screen-2xl">
          {reversedBlogs.map((blog) => (
            <Link key={blog.id} href={`/blogs/blogDetails/${blog.id}`} passHref>
              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <BlogCard
                  imageUrl={blog.imageUrl}
                  date={blog.date}
                  category={blog.category}
                  title={blog.title}
                  description={blog.description}
                />
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Blogs;
